export default __webpack_public_path__ + "static/media/undraw_export_files_re_99ar.01b005a9.svg";